export default {
  privateSubtitle: '¿Desea enviar invitaciones para que respondan esta actividad?',
  publicSubtitle: 'Comparta este enlace con quien desee que responda esta actividad',
  cancel: 'Lo haré después',
  sendForm: 'Enviar actividad',
  shareLink: 'Enlace de compartir'
}
